module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 18
// module chunks = 15 16 17 18 19 20 21 22 23